import { Alert, Button } from '@mui/material';
import * as React from 'react';

interface IProps {
  onCancel: () => void;
}

export const TwoFaAlert: React.FC<IProps> = ({ onCancel }) => {
  return (
    <Alert
      severity="info"
      sx={{ display: 'flex', alignItems: 'center', position: 'absolute', width: '100%' }}
      action={
        <Button onClick={onCancel} variant="text">
          Undo
        </Button>
      }
    >
      2FA has been disabled
    </Alert>
  );
};
